import Figure from "~/components/figure"
import Circuit from "~/components/circuit"
import circuits from "./circuits"
import { Icon } from "evergreen-ui"
import Tabs from "~/components/tabs"

export default class HomeBanner extends Component {
  state = { activeCircuit: "eyes" }

  render() {
    const { activeCircuit } = this.state

    const ZoomedImg = ({ src, size, padding, style, ...props }) => (
      <div
        style={Object.assign({}, style, {
          width: size,
          height: size,
          overflow: "hidden",
          borderRadius: 5,
          position: "relative",
        })}
        {...props}
      >
        <img
          src={src}
          width={size + padding * 2}
          height={size + padding * 2}
          style={{ position: "absolute", left: -padding, top: -padding }}
        />
      </div>
    )

    const NeuronIcon = ({ name, layer, neuron, circuitKey }) => {
      return (
        <Surface
          alignItems="center"
          marginX={20}
          onMouseDown={() => this.setState({ activeCircuit: circuitKey })}
          flexFlow="row"
        >
          <ZoomedImg
            src={neuronFeatureVis("inceptionv1", layer, neuron)}
            size={30}
            padding={10}
            style={{
              borderRadius: 5,
              transition: "300ms ease-out all",
            }}
          />
          <Text
            size={400}
            fontWeight={600}
            marginLeft={10}
            pointerEvents="none"
          >
            {name}
          </Text>
        </Surface>
      )
    }

    const icons = [
      { name: "eyes", layer: "mixed3b", circuitKey: "eyes", neuron: 363 },
      {
        name: "High-low Freq",
        layer: "mixed3a",
        circuitKey: "frequency",
        neuron: 112,
      },
      {
        name: "Triangles",
        layer: "mixed3a",
        circuitKey: "triangles",
        neuron: 188,
      },
      {
        name: "Floppy Ear",
        layer: "mixed4d",
        circuitKey: "floppy",
        neuron: 436,
      },
      { name: "Humans", layer: "mixed4b", circuitKey: "humans", neuron: 493 },
      // { name: "Water", layer: "mixed4d", circuitKey: "water", neuron: 507 },
    ]

    return (
      <React.Fragment>
        <Surface width={1024} alignSelf="center">
          <Tabs
            activeIndex={icons
              .map(({ circuitKey }) => circuitKey)
              .indexOf(activeCircuit)}
            names={icons.map(({ name }) => name)}
            items={icons.map(icon => (
              <NeuronIcon {...icon} />
            ))}
          />
        </Surface>
        <Figure margin={0}>
          <Circuit
            circuitProps={{ inlineLayerNames: true, hasDataset: false }}
            key={activeCircuit}
            circuit={circuits[activeCircuit]}
          />
          <Surface
            justifySelf="center"
            width={1024}
            marginY={5}
            flexFlow="row"
            alignItems="center"
            marginTop={20}
          >
            <Text width={580} fontSize={15}>
              ImageNet models learn to distinguish among dozens of types of
              eyes. The earliest eyes are developed in 3a and are constructed
              out of serrated curves in d2. By 3b, a diversity of specialized
              eyes have started to develop.
            </Text>
            <Surface
              alignItems="center"
              background="white"
              boxShadow="1px 1px 5px rgba(0, 0, 0, 0.05)"
              border
              paddingX={5}
              paddingY={5}
              marginLeft={120}
              borderRadius={5}
              flexFlow="row"
            >
              <Surface
                alignItems="center"
                justifyContent="center"
                position="relative"
                width={50}
                height={50}
                borderRadius={5}
                overflow="hidden"
              >
                <img
                  src={require("./nick.png")}
                  width={50}
                  height={50}
                  style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    top: 0,
                  }}
                />
                <Icon
                  icon="play"
                  color="white"
                  position="absolute"
                  left={"30%"}
                  top={"30%"}
                  opacity={0.6}
                  size={25}
                />
              </Surface>
              <Surface alignItems="center" paddingX={10}>
                <Text
                  textAlign="center"
                  size={500}
                  lineHeight={1.2}
                  opacity={0.7}
                >
                  Circuit walkthrough
                </Text>
                <Text opacity={0.6}>54 seconds</Text>
              </Surface>
            </Surface>
          </Surface>
        </Figure>
      </React.Fragment>
    )
  }
}
